import React, { useContext, useMemo } from 'react'

import { NotifyMe, NotifyMeProps } from '@Components/CMS/NotifyMe'
import { Block, PagePresentation } from '@Generated/graphql'
import { BlockContext } from '@Globals/CMS/Context'
import { getJSONFieldValue, getRTEFieldText } from '@Globals/CMS/FieldHelpers'

const getBlockData = (subscribeBlock: Block): NotifyMeProps => {
  let backgroundColor = 'var(--neutral-200)'
  const fields = subscribeBlock.fields || []

  if (getJSONFieldValue(fields, 'customBackgroundColor')) {
    backgroundColor = getJSONFieldValue(fields, 'backgroundColor') || ''
  }

  return {
    backgroundColor,
    description: getRTEFieldText(fields, 'description') || '',
    identifyingLabel: `subscribe_block_${subscribeBlock.id}`,
    submitText: getJSONFieldValue(fields, 'submitButtonText') || '',
    thankYouText: getRTEFieldText(fields, 'subscribedText') || '',
    title: getJSONFieldValue(fields, 'headline')?.toString() || '',
  }
}

const SubscribeBlock = ({
  id,
  subscribeBlock,
}: {
  id?: string
  subscribeBlock: Block
}) => {
  const { presentation, shouldFillContainer } = useContext(BlockContext)
  const blockProps = useMemo(() => getBlockData(subscribeBlock), [subscribeBlock])

  return (
    <NotifyMe
      {...blockProps}
      fillContainer={shouldFillContainer}
      id={id}
      isInModal={presentation === PagePresentation.Modal}
    />
  )
}

export default SubscribeBlock
